// @ts-nocheck
export const returnDecodedProductId = (productId) => {
  try {
    const urlArr = window.atob(productId).split('/');
    const id = urlArr[urlArr.length - 1];
    return parseInt(id);
  } catch (error) {
    return null;
  }
};

export const returnImpressionFieldObject = (product) => {
  const {
    fields: {
      shopifyData: {
        id,
        title,
        productType,
        vendor,
        priceRange: {
          maxVariantPrice: { currencyCode, amount },
        },
      },
    },
  } = product;

  return {
    name: title,
    price: amount,
    currency: currencyCode,
    collection: productType,
    brand: vendor,
    id: returnDecodedProductId(id),
  };
};

export const returnProductDataLayerObject = (product) => {
  const {
    fields: {
      shopifyData: {
        id,
        title,
        productType,
        vendor,
        priceRange: { maxVariantPrice: { currencyCode, amount } } = {},
        variants,
      } = {},
    } = {},
  } = product;

  return {
    name: title,
    price: amount,
    currency: currencyCode,
    collection: productType,
    category: productType,
    brand: vendor,
    sku: variants[0].sku,
    id: returnDecodedProductId(id),
  };
};

export const returnVariantDataLayerObject = (variant) => {
  const {
    id,
    title,
    productType,
    vendor,
    sku,
    priceV2: { currencyCode, amount },
  } = variant;

  return {
    name: title,
    price: amount,
    currency: currencyCode,
    collection: productType,
    sku,
    category: productType,
    brand: vendor,
    id: returnDecodedProductId(id),
  };
};
